import { render, staticRenderFns } from "./Beneficiaries.vue?vue&type=template&id=31b7bc6c"
import script from "./Beneficiaries.vue?vue&type=script&lang=ts"
export * from "./Beneficiaries.vue?vue&type=script&lang=ts"
import style0 from "./Beneficiaries.vue?vue&type=style&index=0&id=31b7bc6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports